module.exports = "../images/cabin1-v2.jpg?v=25418e6";